// TODO: Read from env variables by placing a correct config inside the eventual docker container
let apiHost = ""
let httpProtocol = "https"

const host = location.host.split(":")[0]
if (host === "localhost" || host === "192.168.178.84") {
    apiHost = `${host}:7070`
    httpProtocol = "http"
} else {
    apiHost = `${host}`
}

const httpHost = () => {
    return `${httpProtocol}://${apiHost}`
}

export default {
    httpHost,
}